// 543 Photo Booths - Mock Data

export const businessInfo = {
  name: '543 Photo Booths',
  phone: '(336) 594-3269',
  email: 'info@543photobooths.com',
  serviceArea: 'Central North Carolina',
  logo: 'https://customer-assets.emergentagent.com/job_booth-magic-1/artifacts/ay9exw5e_logo.png'
};

export const packages = [
  {
    id: 1,
    name: 'Drop-Off Booth',
    price: 400,
    description: 'We deliver, set up, and pick up the booth for you. Perfect for hassle-free events.',
    features: [
      'Professional delivery & setup',
      'All-day rental',
      'Unlimited photos',
      'Digital gallery access',
      'On-site setup assistance',
      'Professional breakdown & pickup'
    ],
    popular: true
  },
  {
    id: 2,
    name: 'Pick-Up Booth',
    price: 275,
    description: 'Pick up the booth yourself and save. Easy setup instructions included.',
    features: [
      'Self pick-up & return',
      'All-day rental',
      'Unlimited photos',
      'Digital gallery access',
      'Easy setup guide',
      'Phone support included'
    ],
    popular: false
  }
];

export const upgrades = [
  {
    id: 1,
    name: 'Props Package',
    description: 'Fun hats, glasses, signs, and accessories for memorable photos',
    icon: 'Sparkles'
  },
  {
    id: 2,
    name: 'Custom Backdrops',
    description: 'Choose from premium backdrops or provide your own custom design',
    icon: 'Image'
  },
  {
    id: 3,
    name: 'Wireless Operation',
    description: 'Guests can control the booth from their phones',
    icon: 'Wifi'
  },
  {
    id: 4,
    name: 'Red Carpet',
    description: 'Add a touch of glamour with our red carpet setup',
    icon: 'Star'
  },
  {
    id: 5,
    name: 'Video Messages',
    description: 'Record personalized video messages for the hosts',
    icon: 'Video'
  },
  {
    id: 6,
    name: 'GIFs',
    description: 'Create animated GIFs that guests can share instantly',
    icon: 'Film'
  },
  {
    id: 7,
    name: 'Additional Lighting',
    description: 'Professional lighting setup for perfect photos every time',
    icon: 'Sun'
  },
  {
    id: 8,
    name: 'Custom Welcome Screen',
    description: 'Personalized welcome screen with your event details',
    icon: 'Monitor'
  },
  {
    id: 9,
    name: 'Multiple Templates',
    description: 'Choose from various photo strip templates and layouts',
    icon: 'Layout'
  }
];

export const galleryImages = [
  {
    id: 1,
    src: 'https://customer-assets.emergentagent.com/job_booth-magic-1/artifacts/vanwv298_Nickle%20Photography-6.jpg',
    alt: 'Wedding couple at photo booth'
  },
  {
    id: 2,
    src: 'https://customer-assets.emergentagent.com/job_booth-magic-1/artifacts/dean14fe_Nickle%20Photography-7.jpg',
    alt: 'Couple enjoying photo booth'
  },
  {
    id: 3,
    src: 'https://customer-assets.emergentagent.com/job_booth-magic-1/artifacts/dehy8uei_Nickle%20Photography-9.jpg',
    alt: 'Full booth setup at event'
  },
  {
    id: 4,
    src: 'https://customer-assets.emergentagent.com/job_booth-magic-1/artifacts/9k5c76ou_Nickle%20Photography-11.jpg',
    alt: 'Guests using photo booth'
  },
  {
    id: 5,
    src: 'https://customer-assets.emergentagent.com/job_booth-magic-1/artifacts/r6k62f1e_Nickle%20Photography-17.jpg',
    alt: 'Modern photo booth setup'
  }
];

export const howItWorks = [
  {
    step: 1,
    title: 'Choose Your Package',
    description: 'Select between our Drop-Off or Pick-Up booth rental options.'
  },
  {
    step: 2,
    title: 'Customize Your Experience',
    description: 'Add upgrades like props, backdrops, and custom templates.'
  },
  {
    step: 3,
    title: 'Enjoy Your Event',
    description: 'Your guests capture unlimited memories all day long.'
  },
  {
    step: 4,
    title: 'Share & Cherish',
    description: 'Access your digital gallery and share photos instantly.'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Sarah M.',
    event: 'Wedding Reception',
    quote: 'The photo booth was the highlight of our wedding! Guests are still talking about it.',
    rating: 5
  },
  {
    id: 2,
    name: 'Michael T.',
    event: 'Corporate Event',
    quote: 'Professional service from start to finish. The team made setup incredibly easy.',
    rating: 5
  },
  {
    id: 3,
    name: 'Jessica R.',
    event: 'Birthday Party',
    quote: 'Absolutely loved the GIF feature! Everyone had so much fun with the props.',
    rating: 5
  }
];

export const faqs = [
  {
    question: 'How long is the rental period?',
    answer: 'All booth rentals are for the entire day, giving you maximum flexibility for your event.'
  },
  {
    question: 'What\'s included in the base rental?',
    answer: 'Every rental includes the photo booth, unlimited photos, digital gallery access, and basic setup instructions (for pick-up) or professional setup (for drop-off).'
  },
  {
    question: 'How far in advance should I book?',
    answer: 'We recommend booking at least 2-4 weeks in advance, especially for weekend events. Popular dates fill up quickly!'
  },
  {
    question: 'What areas do you serve?',
    answer: 'We proudly serve Central North Carolina and surrounding areas. Contact us to confirm service in your location.'
  },
  {
    question: 'Can I customize the photo templates?',
    answer: 'Yes! With our Multiple Templates upgrade, you can choose from various layouts or request a custom design to match your event theme.'
  },
  {
    question: 'How do guests receive their photos?',
    answer: 'Guests can instantly share photos via text, email, or social media. All photos are also available in a private digital gallery.'
  }
];
